import {
  callApexRest
} from '../library/aws'

import {
  UPDATE_USER_ATTRIBUTES
} from './../stores/auth'

const initialState = {
  order: {}
}

const UPDATE_ORDER = 'order/UPDATE_ORDER'

export const PRODUCT_NAME_COLUMN = 'concatenatedProductName'
export const AIRING_STATIONS_COLUMN = 'airingStations'
export const DELIVERY_LOCATIONS_COLUMN = 'deliveryLocations'
export const DELIVERY_STATUS_COLUMN = 'deliveryStatus'
export const DELIVERY_CONFIRMED_COLUMN = 'deliveryConfirmedTime'
export const DISCOUNT_COLUMN = 'discount'
export const QUANTITY_COLUMN = 'quantity'
export const UNIT_PRICE_COLUMN = 'unitPrice'
export const TOTAL_COLUMN = 'total'
export const PRODUCT_NAME_COLUMN_FRIENDLY = 'Description'
export const AIRING_STATIONS_COLUMN_FRIENDLY = 'Airing Station(s)'
export const DELIVERY_LOCATIONS_COLUMN_FRIENDLY = 'Delivery Location(s)'
export const DELIVERY_STATUS_COLUMN_FRIENDLY = 'Delivery Status'
export const DELIVERY_CONFIRMED_COLUMN_FRIENDLY = 'Delivery Confirmed (GMT)'
export const DISCOUNT_COLUMN_FRIENDLY = 'Discount'
export const QUANTITY_COLUMN_FRIENDLY = 'Quantity'
export const UNIT_PRICE_COLUMN_FRIENDLY = 'Unit Price'
export const TOTAL_COLUMN_FRIENDLY = 'Total'

export const FILE_NAME_COLUMN = 'filenameWithExtension'
export const FILE_SIZE_COLUMN = 'filesize'
export const FILE_LINK_COLUMN = 'link'
export const FILE_OTHER_COLUMN = 'otherDetails'
export const FILE_NAME_COLUMN_FRIENDLY = 'Name'
export const FILE_SIZE_COLUMN_FRIENDLY = 'Size'
export const FILE_LINK_COLUMN_FRIENDLY = 'Download Link'
export const FILE_OTHER_COLUMN_FRIENDLY = 'Details'

const handler = (state = initialState, action) => {
  const {payload, id} = action
  const {order} = state

  switch (action.type) {
    case UPDATE_ORDER:
      order[id] = {
        ...order[id],
        ...payload
      }

      return {
        ...state,
        order: {
          ...order
        }
      }

    default:
      return state
  }
}

export const requestOrder = id => {
  return async (dispatch, getState) => {
    dispatch({
      type: UPDATE_ORDER,
      id,
      payload: {
        fetched: false,
        loading: true,
        hasError: false,
        error: ''
      }
    })

    try {
      const data = await callApexRest('ORDER', null, id)

      const {
        order,
        orderLines,
        orderHasDiscounts,
        orderHasAberFastDelivery,
        contactFullName,
        contactEmailAddress,
        primaryAccountName,
        primaryPostOpsAccountManagerName,
        primaryPostOpsAccountManagerEmail,
        primaryPostOpsAccountManagerPhone,
        primaryLiveOpsAccountManagerName,
        primaryLiveOpsAccountManagerEmail,
        primaryLiveOpsAccountManagerPhone,
        primaryAccountSalesEngineerName,
        primaryAccountSalesEngineerEmail,
        primaryAccountSalesEngineerPhone,
        showInvoicesTab
      } = data

      dispatch({
        type: UPDATE_USER_ATTRIBUTES,
        payload: {
          contactName: contactFullName,
          contactEmail: contactEmailAddress,
          accountName: primaryAccountName,
          primaryPostOpsAccountManagerName,
          primaryPostOpsAccountManagerEmail,
          primaryPostOpsAccountManagerPhone,
          primaryLiveOpsAccountManagerName,
          primaryLiveOpsAccountManagerEmail,
          primaryLiveOpsAccountManagerPhone,
          primaryAccountSalesEngineerName,
          primaryAccountSalesEngineerEmail,
          primaryAccountSalesEngineerPhone,
          showInvoicesTab
        }
      })

      orderLines.forEach((f, i) => f['#'] = i + 1)
      order.orderHasDiscounts = orderHasDiscounts
      order.orderHasAberFastDelivery = orderHasAberFastDelivery

      dispatch({
        type: UPDATE_ORDER,
        id,
        payload: {
          fetched: true,
          ...order,
          orderLines
        }
      })
    } catch (e) {
      dispatch({
        type: UPDATE_ORDER,
        id,
        payload: {
          error: e.message,
          hasError: true
        }
      })
    }

    dispatch({
      type: UPDATE_ORDER,
      id,
      payload: {
        loading: false
      }
    })
  }
}

export const requestOrderFiles = id => {
  return async (dispatch, getState) => {
    dispatch({
      type: UPDATE_ORDER,
      id,
      payload: {
        fetchedOrderFiles: false,
        loading: true,
        hasError: false,
        error: ''
      }
    })

    try {
      const data = await callApexRest('ORDER_FILES', null, id)
      let {files} = data

      files.forEach((f, i) => f['#'] = i + 1)
      files.filter(f => f.link)

      dispatch({
        type: UPDATE_ORDER,
        id,
        payload: {
          files: data.files
        }
      })
    } catch (e) {
      dispatch({
        type: UPDATE_ORDER,
        id,
        payload: {
          error: e.message,
          hasError: true
        }
      })
    }

    dispatch({
      type: UPDATE_ORDER,
      id,
      payload: {
        fetchedOrderFiles: true,
        loading: false
      }
    })
  }
}

export const requestOrderCSV = id => {
  return async (dispatch, getState) => {
    const {
      order
    } = getState().stores.order

    const selectedOrder = order[id]
    if (!selectedOrder || !selectedOrder.orderLines) return

    let csvBody = ''

    const {
      orderName,
      programVersion,
      episodeTitleAndFileName,
      episodeNumber,
      sourceFileName,
      orderStatus,
      accountName,
      totalPrice,
      hasAccessToOrderTotals
    } = selectedOrder

    const datenow = new Date().toISOString()
    
    csvBody +=
      'Account,' + accountName +
      '\nOrder,' + orderName

    if(programVersion) {
      csvBody += '\nProgram,' + programVersion.replace(',', '')
    }

    if(episodeTitleAndFileName) {
      csvBody += '\nEpisode Title,' + episodeTitleAndFileName.replace(',', '')
    }

    if(episodeNumber) {
      csvBody += '\nEpisode Number,' + episodeNumber.replace(',', '')
    }

    if(sourceFileName) {
      csvBody += '\nSource Media,' + sourceFileName.replace(',', '')
    }

    if(orderStatus) {
      csvBody += '\nOrder Status,' + orderStatus
    }      
    
    if(hasAccessToOrderTotals) {
      csvBody += '\nTotal Price,$' + totalPrice
    }
    
    csvBody += '\nCSV Generated On, ' + datenow
    
    csvBody += '\n\nLine Items\n'
    csvBody += '#,Description,Airing Station(s),Delivery Location,Delivery Status,Delivery Confirmed (GMT)'
    
    if(hasAccessToOrderTotals) {
      csvBody += ',Quantity,Unit Price,Discount,Total'
    }
    
    selectedOrder.orderLines.forEach(e => {
      csvBody += '\n' +
        e['#'] +
        ',' + e['concatenatedProductName']

      if(e['airingStations']) {
        csvBody += ',' + e['airingStations'].join(' | ')
      }
      else {
        csvBody += ','
      }

      if(e['deliveryLocations']) {
        csvBody += ',' + e['deliveryLocations'].join(' | ')
      }
      else {
        csvBody += ','
      }

      if(e['deliveryStatus']) {
        csvBody += ',' + e['deliveryStatus']
      }
      else {
        csvBody += ','
      }

      if(e['deliveryConfirmedTime']) {
        csvBody += ',' + e['deliveryConfirmedTime']
      }
      else {
        csvBody += ','
      }

      if(hasAccessToOrderTotals) {
        csvBody += ',' + e['quantity'] + ',$' + e['unitPrice'] + ',' + e['discount'] + '%,$' + e['total']
      }
    })

    const filename = orderName + '_' + datenow + '.csv'
    const uri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvBody)
    
    const downloadLink = document.createElement('a')
    
    downloadLink.href = uri
    downloadLink.download = filename
    
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }
}

export default handler